import { FormControlLabel, Switch } from '@mui/material'
import React from 'react'

import AiUsageHelper from './ai-usage-helper'

type Props = {
  useAi: boolean
  onChange: (value: boolean) => void
}

const SpeechTranscribeToggle: React.FC<Props> = ({ useAi, onChange }) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked),
    [onChange],
  )

  return (
    <div>
      <FormControlLabel
        className="speech-transcribe-toggle"
        control={<Switch checked={useAi} onChange={handleChange} />}
        label="AI enhanced answer recognition"
      />
      <AiUsageHelper text="We use AI to choose the answer." />
    </div>
  )
}

export default SpeechTranscribeToggle
